import { SUBJECT_TYPE } from "../../../../Constants/Enums/Subject.enums";
import { getValue } from "../../../../utils/object.utils";

export interface SubjectColumn {
  subject_id: number;
  subject_name: string;
  short_name: string | null;
  subject_type: SUBJECT_TYPE;
  full_marks: number;
}

/** Prefer the subject's short_name for compact column headers, falling
 * back to its full name when no short_name is available. */
export const getSubjectColumnTitle = (column: SubjectColumn) =>
  column.short_name || column.subject_name;

/**
 * HOLISTIC and GRADE_SPECIFIC subjects are graded directly (no marks entry),
 * so they only need a single "Grade" column. ACADEMIC subjects need both
 * a "Marks" column (editable) and a "Grade" column (auto-computed).
 */
export const isGradeOnlySubject = (subjectType: SUBJECT_TYPE) =>
  subjectType === SUBJECT_TYPE.HOLISTIC ||
  subjectType === SUBJECT_TYPE.GRADE_SPECIFIC;

/**
 * Builds the ordered, de-duplicated list of subject columns from whichever
 * students on the page have result_entries. All students for the same
 * result share the same subject configuration, but this stays defensive
 * in case any student's entries arrive in a different order.
 */
export const getSubjectColumns = (studentList: any[]): SubjectColumn[] => {
  const columnsBySubjectId = new Map<number, SubjectColumn>();

  studentList.forEach((student) => {
    const entries = getValue(student, "result_entries", []);
    entries.forEach((entry: any) => {
      if (!columnsBySubjectId.has(entry.subject_id)) {
        columnsBySubjectId.set(entry.subject_id, {
          subject_id: entry.subject_id,
          subject_name: entry.subject_name,
          short_name: getValue(entry, "short_name", null),
          subject_type: entry.subject_type,
          full_marks: entry.full_marks,
        });
      }
    });
  });

  return Array.from(columnsBySubjectId.values());
};
